export default {
    interests: null,
    interestList: null,
    userInterests: null,
    error: {
        show: false,
        message: ''
    }
}



// WEBPACK FOOTER //
// ./src/store/interest/state.js